<template>
  <div>
    <div style="height:60px" class="hidden-md-and-up"></div>
    <h2>Buzón Digital de Notificaciones</h2>
    <v-layout row wrap>
      <v-flex d-flex lg6 xs12>
        <v-card class="elevation-20 px-3 pb-2 border-primary">
          <v-card-title primary-title class="title font-weight-bold">Ciudadania Digital</v-card-title>
          <v-card-text class="text-xs-justify">
            {{this.$store.state.msg.ciudadania_digital}}
            <div class="text-xs-center"  >
              <Contador :valor="conteoCiudadania" :descripcion="abogadosCiudadanos.conteo.descripcion" />
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              small
              color="primary lighten-3"
              @click="redirect('http://gob.bo/ciudadania/#')"
            >Ir a la Pagina Oficial de Ciudadania Digital</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex d-flex lg6 xs12>
        <v-card class="elevation-20 px-3 border">
          <v-card-title primary-title class="title font-weight-bold">Ley 1173</v-card-title>
          <v-card-text class="text-xs-justify">{{this.$store.state.msg.ley1173}}</v-card-text>
          <v-spacer></v-spacer><v-img :src="require('@/assets/logo1173.png')" contain aspect-ratio="5"></v-img>
        </v-card>
      </v-flex>
    </v-layout>
    <section>
      <br />
      <h2>¿Como Registrarse?</h2>
      <br />
      <v-layout row wrap>
        <v-flex lg12>
          <v-card class="elevation-20 border-primary">
            <v-toolbar color="default" class="title font-weight-bold elevation-0">
              Registrate en Oficinas del RPA
            </v-toolbar>
          
            <v-card-text class="text-sm-justify pa-0 pb-3">
              <v-subheader>Procedimiento</v-subheader>
              <v-layout row wrap subheader>
                <v-flex xl1 xs2 class="text-xs-center">
                  <v-icon>phonelink</v-icon>
                </v-flex>
                <v-flex xl11 xs9 class="text-xs-left">
                  {{this.$store.state.msg.registro_ciudadania.paso0}}
                  <br />
                  <v-btn
                  small
                    color="primary"
                    @click="redirect('https://www.gob.bo/ciudadania/registrate')"
                  >Registrarme</v-btn>
                </v-flex>
                <v-flex xl1 xs2 class="text-xs-center">
                  <v-icon>location_on</v-icon>
                </v-flex>
                <v-flex xl11 xs9 class="text-xs-left">
                  {{this.$store.state.msg.registro_ciudadania.paso1}}
                  <br />
                  <v-btn
                  small
                    color="primary lighten-3"
                    @click="redirect('https://gob.bo/ciudadania/entidades')"
                  >Ver Puntos de Registro</v-btn>
                </v-flex>
                <v-flex xl1 xs2 class="text-xs-center">
                  <v-icon>assignment_ind</v-icon>
                </v-flex>
                <v-flex
                  xl11
                  xs9
                  class="text-xs-left"
                >
                  <span v-html="this.$store.state.msg.registro_ciudadania.paso2"></span>
                </v-flex>
                <v-flex xl1 xs2 class="text-xs-center">
                  <v-icon>done_outline</v-icon>
                </v-flex>
                <v-flex xl11 xs9 class="text-xs-left">
                  <span v-html="this.$store.state.msg.registro_ciudadania.paso3"></span>
                  <br />
                  <v-btn small color="primary">Ver Pasos para la Activación</v-btn>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </section>
    <section>
      <br />
      <h2>¿Dónde puedo ingresar con mi cuenta de Ciudadanía Digital?</h2>
      <br />
      <v-layout row wrap>
        <v-flex d-flex lg6>
          <v-card class="elevation-20 border-primary">
            <v-card-title
              primary-title
              class="title font-weight-bold"
            >Seguimiento a los Tramites del RPA</v-card-title>
            <v-card-text class="text-xs-justify pa-1">
              <v-layout row wrap class="mb-3">
                <v-flex xs10 offset-xs1>
                  Ingrese con su cuenta de <b>Ciudadanía Digital</b> para realizar el seguimiento a los siguientes tramites:
                  <li>Registro y matriculación</li>
                  <li>Reposición y renovación de la credencial</li>
                  <li>Certificación</li>
                  <li>Registro de RUANNA</li>
                  <li>Sanciones</li>
                  <li>Sobres de postulación</li>
                  <li>Cursos</li>
                  <li>Búsqueda</li>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="redirect('https://sra.justicia.gob.bo')"
                small
              >
                <v-avatar size="20" class="px-3">
                  <img
                    :src="require('@/assets/rpablanco.png')"
                    alt="Logo del Registro Publico de la Abogacia"
                  />
                </v-avatar>Ingresar al Sistema de Registro de la Abogacía
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex d-flex lg6>
          <v-card class="elevation-20 border-primary">
            <v-card-title
              primary-title
              class="title font-weight-bold"
            >Control tu cuenta de Ciudadanía Digital</v-card-title>
            <v-card-text class="text-xs-justify pa-1">
              <v-layout row wrap class="mb-3">
                <v-flex xs10 offset-xs1>
                  En tu cuenta de Ciudadanía Digital puedes cambiar la siguiente información:
                  <li>Contraseña</li>
                  <li>Correo electrónico</li>
                  <li>Número de celular</li>
                  <li>Habilitar notificaciones de tus trámites.</li>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary lighten-5" @click="redirect('https://www.gob.bo/ciudadania/')" small>
                <v-avatar size="20" class="px-3">
                  <img
                    src="https://www.gob.bo/ciudadania/ciudadania/dist/client/img/logo_ciudadania_digital_n.5f5aad1.png"
                    alt="Logo de Ciudadania Digital"
                  />
                </v-avatar>Ingresar a tu Cuenta
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex>
        <!-- <v-flex d-flex lg4>
          <v-card class="elevation-20 border-primary">
            <v-card-title primary-title class="title font-weight-bold">Buzon de Notificaciones</v-card-title>
            <v-card-text class="text-xs-left pa-1">
              <v-layout row wrap class="mb-3">
                <v-flex xs10 offset-xs1>Verifica Tu bandeja de Notificaciones Digitales</v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                @click="redirect('https://www.gob.bo/notificaciones/bpm-client/#/login')"
                small
              >
                <v-avatar size="20" class="px-3">
                  <img
                    src="https://www.gob.bo/ciudadania/ciudadania/dist/client/img/3262e0c.svg"
                    alt="Logo de Ciudadania Digital"
                  />
                </v-avatar>Ingresar a tu Buzón
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-flex> -->
      </v-layout>
    </section>
  </div>
</template>
<script>
import Contador from "@/components/Inicio/Contador";
export default {
  components: {
    Contador
  },
  data() {
    return {
      abogadosCiudadanos: {
        conteo: {
          descripcion: "Abogadas(os) con Ciudadania Digital"
        }
      }
    };
  },
  computed:{
     conteoCiudadania(){
       return this.$store.state.cantidad.ciudadania
     } 
  },
  mounted: function() {
    if (this.$vuetify.breakpoint.width > 960) {
      this.$vuetify.goTo(60);
    } else {
      this.$vuetify.goTo(0);
    }
  },
  methods: {
    redirect(url) {
      window.open(url);
    }
  }
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Ciudadania/index.vue